<template>
  <div>
    <div :class="{ 'is-flex': is_flex }" class="is-align-items-flex-start">
      <p><b>{{payload.designator}}:</b></p>
      <div v-if="is_flex" class="horizontal_space"></div>
      <div class="blue_text btn">
        <p v-if="showCreateButton" @click="createText">{{ getCreateButtonText }}</p>
        <p v-else @click="editText" v-html="$sanitize(payload.text_data.content)" class="white_space_pre_line break_word"></p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'resource-text-editor',
  props: {
    payload: {
      type: Object,
      default: undefined
    },
    is_flex: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getCreateButtonText () {
      return this.payload.init_content == undefined ? 'CREATE' : this.payload.init_content
    },
    showCreateButton () {
      return this.payload.text_data == undefined || this.payload.text_data.id == undefined || this.payload.text_data.content == undefined || this.payload.text_data.content.length == 0
    }
  },
  methods: {
    createText () {
      this.create({
        designator: 'resource-text-editor-modal',
        component_name: 'TextsForm',
        is_create: true,
        init_designator: this.payload.designator,
        init_content: this.payload.init_content,
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id,
        data: {
          designator: this.payload.designator
        },
        company_id: this.payload.company_id,
        modal_title: 'Create new Text'
      })
    },
    editText () {
      this.create({ designator: 'resource-text-editor-modal', component_name: 'TextsForm', data: this.payload.text_data, resource_type: this.payload.resource_type, resource_id: this.payload.resource_id, company_id: this.payload.company_id, modal_title: this.payload.designator })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
